<div nxLayout="grid maxwidth" class="bottom-divider">
  <cpc-illustration name="manAndWomanUnderUmbrelaButDogWillGetWet"
    width="264px">
  </cpc-illustration>
</div>
<div class="footer">
  <div nxLayout="grid maxwidth">
    <div nxRow>
      <div nxCol="12">
        <!--<div class="app-footer">-->
        <footer nx-footer>

          <nx-footer-copyright>
            &copy; Allianz 2021
          </nx-footer-copyright>

          <nx-footer-navigation>
            <nx-footer-link>
              <a href="{{'footer.privacy-policy-url' | translate}}"
                target="_blank" translate>footer.privacy-policy</a>
            </nx-footer-link>
            <nx-footer-link>
              <a href="{{'footer.terms-of-use-url' | translate}}"
                target="_blank" translate>footer.terms-of-use</a>
            </nx-footer-link>
            <nx-footer-link>
              <a href="{{'footer.ek-policy-url' | translate}}" target="_blank"
                translate>footer.ek-policy</a>
            </nx-footer-link>

            <nx-footer-link>
              <cpc-phone-link [phoneNumber]="hotlineNumber"
                label="{{'footer.hotline' | translate}}">
              </cpc-phone-link>
            </nx-footer-link>

          </nx-footer-navigation>

        </footer>
        <!--</div>-->
      </div>
    </div>
  </div>
</div>
